module.exports = __webpack_public_path__ + "media/images/world-map-dot-070211058faf461a64d10b2f492e80e9.svg";